module.exports = __webpack_public_path__ + "img/68.a4082ec4.png";